export enum ProfileRouteSegment {
  MyTeam = 'my-team',
  AddressBook = 'address-book',
  ProductListing = 'product-listing',
  ProductCatalog = 'product-catalog',
  ProfileAndNotifications = 'profile-and-notifications',
  QuoteDefaults = 'quote-defaults',
  LocalVatRegistrations = 'local-vat-registrations',
}
